import { Box } from '@hakimo-ui/hakimo/types';
import { HakimoSpinner } from '@hakimo-ui/shared/ui-base';
import { useEffect, useRef, useState } from 'react';
import VideoHighlightBox from './VideoHighlightBox';

interface Props {
  videosUrls: string[];
  currentVideoIndex: number;
  onNextVideo: () => void;
  videoUrlToBoxesMap: Record<string, Box[]>;
}

export function MultiVideoPlayer(props: Props) {
  const { videosUrls, currentVideoIndex, onNextVideo, videoUrlToBoxesMap } =
    props;
  const currentVideoUrl = videosUrls[currentVideoIndex];
  const [isBuffering, setIsBuffering] = useState(true);

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    const onEndhandler = () => {
      onNextVideo();
    };
    const onWaitingHandler = () => {
      setIsBuffering(true);
    };
    const onPlayingHandler = () => {
      setIsBuffering(false);
    };
    if (videoElement) {
      videoElement.addEventListener('ended', onEndhandler);
      videoElement.addEventListener('waiting', onWaitingHandler);
      videoElement.addEventListener('playing', onPlayingHandler);
    }
    return () => {
      videoElement?.removeEventListener('ended', onEndhandler);
      videoElement?.removeEventListener('waiting', onWaitingHandler);
      videoElement?.removeEventListener('playing', onPlayingHandler);
    };
  }, [currentVideoUrl]);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement && videoElement.paused) {
      try {
        const playPromise = videoElement.play();
        playPromise.catch((error) => {
          // eslint-disable-next-line no-console
          console.error('video cant be played', {
            videoUrl: currentVideoUrl,
            error,
          });
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('video cant be played', {
          videoUrl: currentVideoUrl,
          error,
        });
      }
    }
  }, [currentVideoUrl]);

  return (
    <>
      <video
        ref={videoRef}
        className="peer aspect-video h-full w-full rounded-md bg-inherit object-fill" //pointer-events-none
        muted
        controls={false}
        preload="auto"
        // autoPlay
      >
        <source src={currentVideoUrl} type="video/mp4"></source>
      </video>
      {isBuffering && (
        <div className="absolute inset-0 flex items-center justify-center">
          <HakimoSpinner />
        </div>
      )}
      {!isBuffering && (
        <VideoHighlightBox
          boxes={videoUrlToBoxesMap[currentVideoUrl]}
          videoRef={videoRef}
          videoHeight={videoRef.current?.videoHeight}
          videoWidth={videoRef.current?.videoWidth}
          videoRect={videoRef.current?.getBoundingClientRect()}
        />
      )}
    </>
  );
}
